export default __webpack_public_path__ + "static/1-df15f12c9018b4b77a9d9357ad748485.jpeg";